module.exports = __webpack_public_path__ + "static/media/skip-fw.76c6efc9.svg";